import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-top",
  "use": "icon-arrow-top-usage",
  "viewBox": "0 0 24 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 15\" id=\"icon-arrow-top\">\n  <path id=\"icon-arrow-top_Path_1116\" data-name=\"Path 1116\" d=\"M12,0,0,12.171,2.829,15,12,5.661,21.171,15,24,12.171Z\" transform=\"translate(0)\" fill=\"#3f45d1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol